import {ManagementTransformBase} from "../TranformBase";

import {
  AssistantVoiceCompactModel,
  AssistantVoiceGenderModel,
  AssistantVoiceEvenCompactModel,
  AssistantVoiceEngineTypeModel,
  AssistantVoiceSynthesizerModel,
  AssistantVoiceRecordModel,
  AssistantVoiceCallListModel,
  AssistantVoiceCallListQueryModel,
} from "@/api/models/assistants";
import {
  Assistant,
  GetElevenLabsVoiceList200,
  GetElevenLabsVoiceListParams,
  Voice,
  VoiceTypeParameter,
} from "@/api/services";

export class AssistantVoicesTransform extends ManagementTransformBase<AssistantVoiceRecordModel> {
  // TODO(future): use function overloading for other DTO inputs.
  public makeCompactModel(dto: Assistant): AssistantVoiceCompactModel {
    const model: AssistantVoiceCompactModel = {
      id: dto.voice_id,
      name: dto.voice_name,
      audioUrl: dto.voice_preview_url || null,
      accent: dto.voice_accent,
      engine: {type: dto.voice_engine_type as AssistantVoiceEngineTypeModel},
      // engine: {type: AssistantVoiceEngineTypeModel.V2},
      gender: dto.voice_gender as AssistantVoiceGenderModel,
      isOwner: dto.voice_is_owner,
      provider: dto.voice_provider,
      synthesizer: dto.voice_synthesizer as AssistantVoiceSynthesizerModel,
    };

    return model;
  }

  public makeEvenCompactModel(dto: string): AssistantVoiceEvenCompactModel {
    const model: AssistantVoiceEvenCompactModel = {
      engine: {
        type: dto as AssistantVoiceEngineTypeModel,
      },
    };

    return model;
  }

  public makeRecordModel(dto: Voice): AssistantVoiceRecordModel {
    const model: AssistantVoiceRecordModel = {
      id: dto.voice_id,
      title: dto.name,
      description: dto.description,
      is_recommended: dto.is_recommended,
      audioUrl: dto.preview_url,
      language: dto.language,
      gender: dto.gender,
      category: dto.category,
      accent: dto.accent,
    };

    return model;
  }

  public makeListModel(
    dto: GetElevenLabsVoiceList200,
  ): AssistantVoiceCallListModel {
    const model: AssistantVoiceCallListModel = {
      records: dto.items.map(item => this.makeRecordModel(item as Voice)),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }

  public makeGetQueryDto(
    model: AssistantVoiceCallListQueryModel,
  ): GetElevenLabsVoiceListParams {
    const dto: GetElevenLabsVoiceListParams = {
      page_number: model.current + 1,
      page_size: model.size,
      voice_type: model.voiceCategory as VoiceTypeParameter,
      workspace_id: model.workspaceId,
      accent: model.accent,
      gender: model.gender,
      language: model.language,
      search: model.search,
    };

    return dto;
  }
}
export const assistantVoicesTransform = new AssistantVoicesTransform();
